import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  yourCarriersSelectionTitle: {
    defaultMessage: 'Your Carriers',
    description: 'Title for the collapsible area where user selects if they want access to the Your Carriers feature.',
    id: 'TdLNVc',
  },
  yourCarriers: {
    defaultMessage: 'Your Carriers',
    id: '2A2594',
    description: 'Your Carriers label',
  },
  yourCarriersDescription: {
    defaultMessage: 'Connect as many of your own carrier accounts as you like for an additional {byoaCharge}/mo.',
    id: 'uxvRxL',
    description: 'Your Carriers description',
  },
  yourCarriersDescriptionIncluded: {
    defaultMessage: 'Connect as many of your own carrier accounts as you like. Included.',
    id: 'IXY+Pt',
    description: "Your Carriers description for sellers who have the feature included (alpha, trial, or bundled) and can't turn it off",
  },
  yourCarriersDescriptionFreeDuringTrial: {
    defaultMessage: 'Free during your trial. After {trialEndDate} this is {byoaCharge}/mo.',
    id: 'M5Zcij',
    description:
      'Your Carriers description shown during an active trial where BYOA providers are connected; becomes billed after trial ends',
  },
  yourCarriersDescriptionDisabledAfterTrial: {
    defaultMessage: 'Free during your trial. Choose a plan to continue using Your Carriers after {trialEndDate}.',
    id: 'm5v5mq',
    description: 'Your Carriers description shown during an active trial when the seller has no billing plan selected',
  },
  yourCarriersDescriptionHighVolume: {
    defaultMessage: 'No monthly add-on fee for High Volume plans. Invoiced at {fee}¢ per label.',
    id: 'uF3hBG',
    description: 'Your Carriers description for high volume plans',
  },
  yourCarriersFreeLabel: {
    defaultMessage: 'Free',
    id: 'AumwGr',
    description: 'Price label shown in the Your Carriers header when the feature is free during trial with no plan selected',
  },
  byoaSliderLabel: {
    description: 'Bring Your Own Account toggle add on label',
    defaultMessage: 'Activated',
    id: 'xDipze',
  },
  deactivationMessageForCarrierList: {
    defaultMessage: '{numberOfProviders, plural, one {This carrier} other {These carriers}} will deactivate on {date}.',
    description: 'message describing when the Your Carriers feature will deactivate',
    id: 'RFkerl',
  },
  deactivationMessage: {
    defaultMessage: 'Deactivates on {date}.',
    description: 'message describing when the Your Carriers feature will deactivate without a list of carriers',
    id: 'YCEasB',
  },
  warningMessage: {
    defaultMessage: 'Your Carriers will be immediately deactivated upon update',
    description: 'message describing that the user will lose the Your Carriers feature immediately',
    id: '0hpQ3F',
  },
  deactivatedCarriersMessage: {
    description: 'Message showing which carriers can no longer be used',
    defaultMessage: 'You will no longer be able to use services from the following carrier accounts in ShipStation:',
    id: 'btiii3',
  },
  active: {
    description: 'Bring Your Own Account active label',
    defaultMessage: '<i>Active</i>',
    id: '79Ug9r',
  },
  inactive: {
    description: 'Bring Your Own Account inactive label',
    defaultMessage: '<i>Inactive</i>',
    id: '6fBNb2',
  },
});
